import classNames from 'classnames'

import styles from './MultiImageBanner.module.scss'

type Props = {
  images: string[]
}

const MultiImageBanner = ({ images }: Props) => (
  <div className={styles.bannerContainer}>
    {images.map((image, i) => (
      <div
        className={classNames(
          styles.imageBlock,
          styles[i === 0 ? 'left' : i === images.length - 1 ? 'right' : 'middle'],
        )}
        key={i}
        style={{ backgroundImage: `url(${image})` }}
      />
    ))}
  </div>
)

export default MultiImageBanner
